import { WebStorageStateStore } from "oidc-client-ts";
import type { AuthProviderProps } from "react-oidc-context";

const env = import.meta.env;

export const oidcConfig: AuthProviderProps = {
  authority: env.VITE_OIDC_AUTHORITY,
  client_id: env.VITE_OIDC_CLIENT_ID,
  redirect_uri: env.VITE_OIDC_REDIRECT_URI,
  post_logout_redirect_uri: env.VITE_OIDC_POST_LOGOUT_REDIRECT_URI,
  response_type: "code",
  scope: "openid profile email",
  loadUserInfo: true,
  // PKCE habilitado por defecto (response_type=code + no client_secret)
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  // El «state» del flujo PKCE vive por omisión en localStorage, que se comparte
  // entre pestañas, mientras que el usuario resultante vive en sessionStorage,
  // que no. Dos pestañas autenticándose a la vez —lo habitual cuando se prueban
  // varias cuentas— se pisan el state y el canje del código falla sin ruido:
  // Keycloak registra el LOGIN y la aplicación nunca llega a pedir el token.
  // Atado a sessionStorage, cada pestaña lleva su propio flujo de principio a fin.
  stateStore: new WebStorageStateStore({ store: window.sessionStorage }),
  onSigninCallback: () => {
    // Limpiar query params del callback
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};
